// extracted by mini-css-extract-plugin
module.exports = {"planDescriptionList":"PlanDescriptionList_planDescriptionList__3RI0F"};